import React from 'react';
import 'katex/dist/katex.min.css';
import { formulaPattern, normalizeQuestionText, renderFormula } from './questionFormula';
export { normalizeQuestionText, renderFormula } from './questionFormula';

function InlineText({ text }) {
  const pattern = formulaPattern();
  const pieces = [];
  let start = 0;
  for (const match of text.matchAll(pattern)) {
    pieces.push(text.slice(start, match.index));
    const tex = match[1] ?? match[2] ?? match[3] ?? match[4] ?? match[5];
    const result = renderFormula(tex, match[1] !== undefined || match[2] !== undefined);
    pieces.push(result.error
      ? <span key={match.index} className="question-formula-invalid" title="原始公式格式待核对">{match[0]}</span>
      : <span key={match.index} className="question-formula" dangerouslySetInnerHTML={{ __html: result.html }} />);
    start = match.index + match[0].length;
  }
  pieces.push(text.slice(start));
  return <>{pieces}</>;
}

export default function QuestionText({ children, hasImages = false, preview = false }) {
  let text = normalizeQuestionText(children, hasImages);
  // Some source datasets flatten Markdown table rows into one line.
  if (/\|\s*:?-{3,}/.test(text)) text = text.replace(/\|\s*\|/g, '|\n|').replace(/([^\n|])\s*\|(?=[^\n]*\n\|\s*:?-{3,})/, '$1\n|');
  // Keep multiline display formulas in one block without altering source data.
  const protectedText = text.replace(/\$\$[\s\S]*?\$\$|\\\[[\s\S]*?\\\]/g, (value) => value.replace(/\n/g, '\u0000'));
  const lines = protectedText.split('\n').map((line) => line.replace(/\u0000/g, '\n'));
  const blocks = [];
  const cells = (line) => line.trim().replace(/^\|/, '').replace(/\|$/, '').split('|');
  for (let i = 0; i < lines.length; i++) {
    if (lines[i].includes('|') && i + 1 < lines.length && /^\s*\|?[\s:|-]*-{3,}[\s:|-]*\|?\s*$/.test(lines[i + 1])) {
      const rows = [cells(lines[i])]; i += 2;
      while (i < lines.length && lines[i].includes('|')) rows.push(cells(lines[i++]));
      i--;
      blocks.push(preview
        ? <span key={i}><InlineText text={rows.map((row) => row.join(' · ')).join('；')} /></span>
        : <table key={i} className="open-question-material-table"><tbody>{rows.map((row, r) => <tr key={r}>{row.map((cell, c) => <td key={c}><InlineText text={cell} /></td>)}</tr>)}</tbody></table>);
    } else blocks.push(<React.Fragment key={i}><InlineText text={lines[i]} />{i < lines.length - 1 ? '\n' : ''}</React.Fragment>);
  }
  return <span className={`question-text${preview ? ' question-text-preview' : ''}`}>{blocks}</span>;
}
